import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-button_icon-03",
  "use": "icon-button_icon-03-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-button_icon-03\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\" stroke-linecap=\"round\"><path stroke-linejoin=\"round\" d=\"M22 16l-5.032 5L14 18.05\" /><path d=\"M12.061 22h0H4c-1.105 0-2-.814-2-1.818V3.818C2 2.814 2.895 2 4 2h14c1.105 0 2 .814 2 1.818v8.198h0M5 7h12M5 12h7\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol